var React = require('react');

function CheckOrange (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"a","x1":"50%","x2":"50%","y1":"0%","y2":"78.125%"},[React.createElement("stop",{"offset":"0%","stopColor":"#FB711C","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#FA2E58","key":1})])),React.createElement("path",{"fill":"url(#a)","fillRule":"nonzero","d":"M0 6.569l1.198-1.121c1.4.686 2.289 1.208 3.862 2.345C8.02 4.39 9.976 2.665 13.61.374l.39.908c-2.998 2.65-5.193 5.6-8.354 11.344C3.696 10.3 2.395 8.817 0 6.569z","key":1})]);
}

CheckOrange.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13"};

module.exports = CheckOrange;

CheckOrange.default = CheckOrange;



// WEBPACK FOOTER //
// ./src/Assets/Icons/check-orange.svg